import { useAuthStore } from "../../store/authStore.js";

import AppRoutes from "./approutes";
import AuthRoutes from "./authroutes";

const AllRoutes = () => {
  const isLoggedIn = useAuthStore((state) => state?.isLoggedIn || false);

  if (isLoggedIn) {
    return <AppRoutes />;
  } else {
    return <AuthRoutes />;
  }
};

export default AllRoutes;



